export const HOME_PATH = "/";
export const REVIEW_PATH = "/review/:approvalId";
export const DOCUMENT_VIEWER_PATH = "/documents/viewer";
